<template>
	<div>
		<HeaderBar title="不良反应"></HeaderBar>
		<div class="center-box-no-footer">
			<van-form :model="form" ref="form">
				<StaticSingleSelect label="发热" :selectkey.sync="form.bq400blfy.bq400250" :list="booleanList" />
				<StaticSingleSelect label="头痛" :selectkey.sync="form.bq400blfy.bq400251" :list="booleanList" />
				<StaticSingleSelect label="肌肉酸痛" :selectkey.sync="form.bq400blfy.bq400252" :list="booleanList" />
				<StaticSingleSelect label="乏力" :selectkey.sync="form.bq400blfy.bq400253" :list="booleanList" />
				<StaticSingleSelect label="皮疹" :selectkey.sync="form.bq400blfy.bq400254" :list="booleanList" />
				<StaticSingleSelect label="恶心" :selectkey.sync="form.bq400blfy.bq400255" :list="booleanList" />
				<StaticSingleSelect label="呕吐" :selectkey.sync="form.bq400blfy.bq400256" :list="booleanList" />
				<StaticSingleSelect label="腹胀" :selectkey.sync="form.bq400blfy.bq400257" :list="booleanList" />
				<StaticSingleSelect label="腹痛" :selectkey.sync="form.bq400blfy.bq400258" :list="booleanList" />
				<StaticSingleSelect label="腹泻" :selectkey.sync="form.bq400blfy.bq400259" :list="booleanList" />
				<StaticSingleSelect label="失眠" :selectkey.sync="form.bq400blfy.bq400260" :list="booleanList" />
				<StaticSingleSelect label="脱发" :selectkey.sync="form.bq400blfy.bq400261" :list="booleanList" />
				<StaticSingleSelect label="抑郁" :selectkey.sync="form.bq400blfy.bq400262" :list="booleanList" />
				<StaticSingleSelect label="易怒" :selectkey.sync="form.bq400blfy.bq400263" :list="booleanList" />
				<StaticSingleSelect label="焦虑" :selectkey.sync="form.bq400blfy.bq400264" :list="booleanList" />
				<FormNormalInput label="其他" v-model="form.bq400blfy.bq400265" />

				<!--      <FormNormalInput label="发热" v-model="form.bq400blfy.bq400250" readonly />
      <FormNormalInput label="头痛" v-model="form.bq400blfy.bq400251" readonly />
      <FormNormalInput label="肌肉酸痛" v-model="form.bq400blfy.bq400252" readonly />
      <FormNormalInput label="乏力" v-model="form.bq400blfy.bq400253" readonly />
      <FormNormalInput label="皮疹" v-model="form.bq400blfy.bq400254" readonly />
      <FormNormalInput label="恶心" v-model="form.bq400blfy.bq400255" readonly />
      <FormNormalInput label="呕吐" v-model="form.bq400blfy.bq400256" readonly />
      <FormNormalInput label="腹胀" v-model="form.bq400blfy.bq400257" readonly />
      <FormNormalInput label="腹痛" v-model="form.bq400blfy.bq400258" readonly />
      <FormNormalInput label="腹泻" v-model="form.bq400blfy.bq400259" readonly />
      <FormNormalInput label="失眠" v-model="form.bq400blfy.bq400260" readonly />
      <FormNormalInput label="脱发" v-model="form.bq400blfy.bq400261" readonly />
      <FormNormalInput label="抑郁" v-model="form.bq400blfy.bq400262" readonly />
      <FormNormalInput label="易怒" v-model="form.bq400blfy.bq400263" readonly />
      <FormNormalInput label="焦虑" v-model="form.bq400blfy.bq400264" readonly />
      <FormNormalInput label="其他" v-model="form.bq400blfy.bq400265" readonly /> -->

				<div class="page-bottom-box" style="margin: 16px;"  v-show='!savestate'>
					<SaveButton :url="saveUrl" ref="btnSave" back="0" @saveSucess="saveSucess"
						:editMode="form.bq400blfy.guid!=''" class="hide">保存
					</SaveButton>
					<van-button block type="info" @click="SaveInfo">保存</van-button>
				</div>
				<div class="page-bottom-box" style="margin: 16px;" v-show='savestate'>
					<van-button block type="info">提交中……</van-button>
				</div>
			</van-form>
		</div>
	</div>
</template>


<script>
	export default {
		name: 's400Bq400blfyForm',
		data() {
			return {
				modelname: 'bq400blfy',
				form: {
					bq400blfy: {
						id: "0", //编号
						guid: "", //guid编号
						companyGuid: "", //单位编号
						departmentGuid: "", //部门编号
						checkStatus: "", //审核状态
						dataStatus: "", //数据状态
						addUid: "", //添加人编号
						addTime: "", //添加时间
						extend1: "", //扩展字段
						extend2: "", //扩展字段
						extend3: "", //扩展字段
						extend4: "", //扩展字段
						extend5: "", //扩展字段
						bq400250: "否", //发热
						bq400251: "否", //头痛
						bq400252: "否", //肌肉酸痛
						bq400253: "否", //乏力
						bq400254: "否", //皮疹
						bq400255: "否", //恶心
						bq400256: "否", //呕吐
						bq400257: "否", //腹胀
						bq400258: "否", //腹痛
						bq400259: "否", //腹泻
						bq400260: "否", //失眠
						bq400261: "否", //脱发
						bq400262: "否", //抑郁
						bq400263: "否", //易怒
						bq400264: "否", //焦虑
						bq400265: "", //其他
						bq400guid: "", //随访编号
						Bq400_250: '', //发热
						Bq400_251: '', //头痛
						Bq400_252: '', //肌肉酸痛
						Bq400_253: '', //乏力
						Bq400_254: '', //皮疹
						Bq400_255: '', //恶心
						Bq400_256: '', //呕吐
						Bq400_257: '', //腹胀
						Bq400_258: '', //腹痛
						Bq400_259: '', //腹泻
						Bq400_260: '', //失眠
						Bq400_261: '', //脱发
						Bq400_262: '', //抑郁
						Bq400_263: '', //易怒
						Bq400_264: '', //焦虑
						Bq400_265: '', //其他
						Bq400_guid: '', //随访编号
					},

					sempFiles: []
				},

				fullscreenLoading: false,
				booleanList: [],
				//保存接口
				saveUrl: this.$utils.Url.s400 + '/api/S400Bq400blfy/Save',
				bq400: JSON.parse(sessionStorage.getItem('bq400')),
				savestate:false,
			}

		},

		methods: {

			//保存按钮成功回调事件
			saveSucess: function() {
				//调用列表页的closeDialog方法
				//this.Back()
			},

			//加载信息
			LoadInfo: function() {
				var that = this
				var args = {
					bq400guid: this.bq400.guid
				}
				that.$utils.HttpPost(this.$utils.Url.s400 + '/api/S400Bq400blfy/Info', args, function(d) {
					let dataModel = d.Data
					that.$utils.CopyKeyInfo(dataModel, dataModel)
					that.$utils.CopyPro(dataModel, that.form.bq400blfy)
				}, null, null, null);
			},


			//保存信息
			SaveInfo: function() {
				let that = this
				// that.form.sempFiles = that.$refs.normalUpload.GetFileList()
				that.savestate=true
				that.$utils.CopyKeySave(that.form.bq400blfy, that.form.bq400blfy)
				that.$refs.btnSave.Save()
			},
		},
		mounted() {
			let that = this
			// 预处理下拉数组
			that.booleanList = that.$utils.setStandardList(that.$apis.s400Apis.booleanList)
			this.form.bq400blfy.bq400guid = this.bq400.guid
			this.LoadInfo()

		}
	}
</script>

<style scoped>
</style>
